module.exports = __webpack_public_path__ + "img/car-battery.b6ef924c.svg";